import React from 'react';

import { useConfigs } from 'modules/configs';
import PromoBlock from 'pages/components/PromoBlock';
import SiteNavigation from 'pages/Landings/components/SiteNavigation';

import useStyles from './styles';

import PageBottom from '../PageBottom';

interface Props {
    className?: string;
}

const Footer: React.FC<Props> = ({ className }) => {
    const { classes, cx } = useStyles();
    const { entrypoint } = useConfigs();

    return (
        <div className={cx(classes.root, className)}>
            {entrypoint === 'main' && <PromoBlock className={classes.promo} />}
            <SiteNavigation />
            <PageBottom />
        </div>
    );
};

export default Footer;
